import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import NoSleep from 'nosleep.js';

interface NoSleepContextProps {
  enableNoSleep: () => void;
  disableNoSleep: () => void;
  isNoSleepEnabled: boolean;
}

const NoSleepContext = createContext<NoSleepContextProps | undefined>(undefined);

export function NoSleepProvider({ children }: { children: React.ReactNode }) {
  const [isNoSleepEnabled, setIsNoSleepEnabled] = useState(false);
  const noSleep = useMemo(() => new NoSleep(), []);

  const enableNoSleep = () => {
    noSleep.enable();
    setIsNoSleepEnabled(true);
  };

  const disableNoSleep = () => {
    noSleep.disable();
    setIsNoSleepEnabled(false);
  };

  useEffect(() => {
    return () => {
      noSleep.disable();
    };
  }, [noSleep]);

  return (
    <NoSleepContext.Provider value={{ enableNoSleep, disableNoSleep, isNoSleepEnabled }}>
      {children}
    </NoSleepContext.Provider>
  );
}

export const useNoSleep = (): NoSleepContextProps => {
  const context = useContext(NoSleepContext);
  if (!context) {
    throw new Error('useNoSleep must be used within a NoSleepProvider');
  }
  return context;
};

export default NoSleepProvider;
